import React from "react";
import { Banner, Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

export const InactiveBanner: React.FC = () => (
  <Banner
    className={styles.inactiveBannerRootStyle}
    variant="warning"
    title="This sandbox is inactive"
    isDescriptionJsx
    description={
      <Text variant="secondary-md">
        You&apos;re currently viewing the default experience. Post the issue in the{" "}
        <Text asSpan variant="secondary-md" className={styles.slackChannelStyle}>
          #eng-remocal
        </Text>{" "}
        Slack channel for support.
      </Text>
    }
  />
);
